module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"choose-selection":"Escolha uma seleção existente","loading-selections":"Aguarde enquanto carregamos suas seleções","load-more":"Carregar mais"}}')
  delete Component.options._Ctor
}
